import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findEngineeringOrderList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/findEngineeringOrderList?` + params,
        method: 'GET'
    })
}
export const findEngineeringOrderListDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/downloadExcelEngineeringOrder?` + params,
        method: 'GET'
    })
}

export const findProject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}
export const findEngineeringProjectAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/all`,
        method: 'GET'
    })
}
export const findEngineeringProjectFindAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/findAll`,
        method: 'GET'
    })
}

export const editEngineeringOrder = (id, params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/engineeringOrder/${id}`,
        method: 'PUT',
        data: params
    })
}
export const findEngineeringProjectId = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/children/${id}`,
        method: 'GET'
    })
}

export const findUsersByUserTypeAll = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUsersAll?` + params,
        method: 'GET'
    })
}
export const addEngineeringOrder = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/engineeringOrder`,
        method: 'POST',
        data: params
    })
}
export const editAllEngineeringOrder = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/engineeringOrder`,
        method: 'PUT',
        data: params
    })
}
export const findEngineeringOrderById = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/findEngineeringOrderById/${id}`,
        method: 'GET'
    })
}
export const passAudit = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/pass`,
        method: 'PUT',
        data: data
    })
}
export const refusedAudit = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/refused`,
        method: 'PUT',
        data: data
    })
}
export const balancePay = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/balancePay`,
        method: 'PUT',
        data: data
    })
}
export const delItem = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
export const findUserList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUserList?` + params,
        method: 'GET'
    })
}










export const findGuaranteeDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/guarantee/${id}`,
        method: 'GET'
    })
}